import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';

export const timeZoneInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  // Obtiene el nombre de la zona horaria del navegador (ej: "America/Guayaquil")
  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const modifiedReq = req.clone({
    headers: req.headers.set('X-Client-Timezone', clientTimeZone)
  });

  return next(modifiedReq);
};